import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import { isObject, every, isPlainObject, set, size, extend, each, isArray, reduce, map, mapValues, get, values } from 'lodash';
export function printWingsError(baseURL, method, request, response, error, stack) {
  var _context, _context2, _context3, _context4, _context5;

  var stackTitle = _sliceInstanceProperty(stack).call(stack, 0, _indexOfInstanceProperty(stack).call(stack, '\n'));

  var stackMessage = _sliceInstanceProperty(stack).call(stack, _indexOfInstanceProperty(stack).call(stack, '\n'));

  var apiBrowserUrl = _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "http://apibrowser.dev.rexsoftware.com#api=".concat(encodeURIComponent(baseURL), "&service_name=")).call(_context2, _sliceInstanceProperty(method).call(method, 0, _indexOfInstanceProperty(method).call(method, '::')), "&index=method_")).call(_context, _sliceInstanceProperty(method).call(method, _indexOfInstanceProperty(method).call(method, '::') + 2));

  var errorMessage = _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = "Rex API Error\nType: ".concat(error.type, " (")).call(_context4, error.code, ")\nMessage: ")).call(_context3, error.message);

  var warningMessage = '%c %s \n%c%s\n\n%cMethod: %c%s%c\n        %s\n%cRequest: %O\n%cResponse: %O\n%c%s%c%s'; // eslint-disable-next-line no-console

  console.log(warningMessage, 'color: white; font-weight: bold; background-color: darkred;', _concatInstanceProperty(_context5 = "".concat(error.type, " (")).call(_context5, error.code, ")"), 'color: darkred; font-weight: inherit; line-height: 1.75;', error.message, 'color: darkslategray; font-weight: bold', 'color: black; font-style: italic; font-weight: inherit', method, 'color: black; font-style: italic; font-weight: inherit', apiBrowserUrl, 'color: darkslategray; font-weight: bold', request.args, 'color: darkslategray; font-weight: bold', error.type === 'InvalidResponse' ? 'Response follows as Error' : response, 'color: darkslategray; font-weight: bold', stackTitle || '', 'color: slategray; font-weight: inherit', stackMessage || '');

  if (error.type === 'InvalidResponse') {
    // eslint-disable-next-line no-console
    console.log(response.original_response);
  }

  console.error(errorMessage);
}
/**
 * Returns whether 'any' is a blank collection. A blank collection is
 * an array or object that has no defined or non-null properties/items.
 * @example
 *  isBlank({}) // returns true
 *  isBlank({id: null, name: null}) // returns true
 *  isBlank (null) // returns false
 *  isBlank ({id: null, name: 'Akira'}) // returns false
 * @param {Array|Object} collection The collection to iterate over.
 * @returns {boolean}
 */

function isBlank(collection) {
  if (!isObject(collection)) return false;
  return every(collection, function (val) {
    return typeof val === 'undefined' || val === null;
  });
}
/**
 * Recursively traverse a collection, nullifying blank objects/arrays.
 * @param {Array|Object} collection The collection to iterate over.
 * @returns {Array|Object|null} Returns null if collection is blank.
 */


function nullifyDeep(collection) {
  var add = function add(result, key, val) {
    if (isPlainObject(collection)) {
      set(result, key, val);
    } else {
      result.push(val);
    }
  };

  var result = reduce(collection, function (result, value, key) {
    if (isObject(value) && !isBlank(value)) {
      add(result, key, nullifyDeep(value));
    } else if (isBlank(value)) {
      add(result, key, null);
    } else {
      add(result, key, value);
    }

    return result;
  }, isPlainObject(collection) ? {} : []);
  return size(result) && !isBlank(result) ? result : null;
}

function renameProperties(target, propertyNameDictionary) {
  var result = extend({}, target);
  each(propertyNameDictionary, function (newName, oldName) {
    if (oldName in result) {
      result[newName] = result[oldName];
      delete result[oldName];
    }
  });
  return result;
}

function prefixRelevantKeysOnRelatedObjectForServerRequest(relatedObj) {
  // Renames our main properties in the row
  var copiedRelatedObj = renameProperties(relatedObj, {
    id: '_id',
    destroy: '_destroy'
  }); // Renames our the innards of our record-like properties in the row. e.g. contact, listing...

  var result = mapValues(copiedRelatedObj, function (relatedObjValue, relatedObjKey) {
    // This means we've encountered something like a _id or _destroy property. We've likely handled this already, so ignore.
    if (isArray(relatedObjValue) || !isObject(relatedObjValue)) {
      return relatedObjValue;
    } // We can't add our server request prefix onto records that are formatted as 'stubs'. Ignore.


    var hasStubFormattedData = size(relatedObjValue) === 2 && 'id' in relatedObjValue && 'text' in relatedObjValue;
    if (hasStubFormattedData) return relatedObjValue; // We're left with a valid record. We'll start to rename it's (strictly) relevant props by adding our server request prefix. 'id' is always left as 'id'.

    return reduce(relatedObjValue, function (recordObj, val, key) {
      var canPrefix = key !== 'id' && String(key).substr(0, 1) !== '_';
      recordObj[(canPrefix ? '_' : '') + key] = val;
      return recordObj;
    }, {});
  });
  return isBlank(result) ? null : result;
}

function prefixRelevantKeysOnRelatedSetForServerRequest(relatedSet) {
  var result = map(nullifyDeep(relatedSet), prefixRelevantKeysOnRelatedObjectForServerRequest);
  return isBlank(result) ? null : result;
}

function _addServerRequestPrefixesToServerObject(data) {
  var copiedData = renameProperties(data, {
    id: '_id',
    related: '_related'
  }); // Map over related object sets and prefix their relevant keys before returning a new prefix-ready data obj

  var prefixedData = extend({}, copiedData, {
    _related: mapValues(get(data, 'related') || get(data, '_related'), prefixRelevantKeysOnRelatedSetForServerRequest)
  });
  if (isBlank(prefixedData._related)) delete prefixedData._related;
  return prefixedData;
}
/**
 * Returns a new object with _ prefixes added to certain properties within the data object.
 * Ported from rex2.
 * @param {Object} data - The data object.
 * @returns {*}
 */


export function addServerRequestPrefixes(data) {
  if (isArray(data)) {
    return map(data, _addServerRequestPrefixesToServerObject);
  } else {
    return _addServerRequestPrefixesToServerObject(data);
  }
}
/**
 * Returns a new object with _ prefixes stripped from the data object.
 * Ported from rex2.
 * @param {Object} data - The data object
 * @param {String} [prefix='_'] - The prefix (defaults to _)
 * @param {Function} [cbHasPrefix] - Callback for when a key has a prefix to remove.
 * @return {*}
 */

export function stripServerRequestPrefixes(data) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';
  var cbHasPrefix = arguments.length > 2 ? arguments[2] : undefined;

  if (!isObject(data)) {
    return data;
  }

  var prefixLength = prefix.length;
  var result = {};

  for (var key in data) {
    var val = data[key];
    var hasPrefix = key.substr(0, prefixLength) === prefix;

    if (hasPrefix && cbHasPrefix) {
      cbHasPrefix(key);
    }

    var strippedKey = hasPrefix ? key.substr(prefixLength) : key;
    result[strippedKey] = stripServerRequestPrefixes(val, prefix);
  } // If data was an array in the first place, rather than an object,
  // convert it back to an array


  return isArray(data) ? values(result) : result;
}